import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import connect from '~/store/connect';
import { State } from '~/store/types';

const RootPage = ({ loading, isLoggedIn }) => {
  const location = useLocation();

  if (location.pathname !== '/') {
    return null;
  }

  if (loading) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default connect((state: State) => ({
  isLoggedIn: state.auth.isLoggedIn,
  loading: state.auth.loading,
}))(RootPage);
